import BaseUpdateRequest from "@/models/Shared/BaseUpdateRequest";
import JobClosedReason from "@/models/Jobs/JobClosedReason";
import JobStatus from "./JobStatus";

export default class UpdateJobSttusRequest extends BaseUpdateRequest {
    status: JobStatus = JobStatus.Open;
    closedReason: JobClosedReason = 0;
}